@if (loading) {
  <div class="clause-variance-progressbar">
    <div class="clause-variance-progressbar__track">
      <div class="clause-variance-progressbar__fill" [style.width.%]="progressPercent"></div>
      <div class="clause-variance-progressbar__label">
        {{ 'workspaces.analyzingClauseVariance' | transloco }}
        <!-- ({{ totalReviewedPagesAllDocuments }}/{{ totalReviewPagesAllDocuments }} pages) -->
      </div>
    </div>
    <!-- <div class="clause-variance-progressbar__meta">{{ progressPercent }}% complete</div> -->
  </div>
}
